import Reflux from 'reflux';

const SimulatorActions = Reflux.createActions({
  simulate: { asyncResult: true },
});

export default SimulatorActions;
